import React from 'react'
import { FormControlLabel, Radio } from '@mui/material'
import { Theme } from '@mui/material/styles'

import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()((theme: Theme) => ({
  radioLabel: {
    marginLeft: 0,
    paddingRight: theme.spacing(3),
  },
  radio: {
    paddingLeft: 0,
  },
}))

export type RadioButtonWithLabelProps<T = string> = { value?: string; label: T }

const RadioButtonWithLabel: React.FC<RadioButtonWithLabelProps> = ({
  value,
  label,
}: RadioButtonWithLabelProps) => {
  const { classes } = useStyles()
  return (
    <FormControlLabel
      value={value}
      control={<Radio className={classes.radio} color={'primary'} />}
      label={label}
      className={classes.radioLabel}
    />
  )
}

export default RadioButtonWithLabel
